import React, { useState, useEffect } from "react";
import docqueimg from "../../../Assets/Images/doctordp1.jpeg";
import kuberan from "../../../Assets/Images/doctordp2.jpeg";
import { IoMdVideocam } from "react-icons/io";
import { IoIosCloseCircle } from "react-icons/io";
import moment from "moment";
import ConsultationService from "../../../Services/ConsultationService";
import PatientService from "../../../Services/PatientService";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import { useHistory, useLocation } from "react-router-dom";
import CommonFunctions from "../../Shared/CommonFunctions";
import { Flex, Drawer, message, Spin } from "antd";
import { IoCloseSharp, IoReloadCircle } from "react-icons/io5";
import { GrRefresh } from "react-icons/gr";
import Quie from "../../../Assets/Icons/patientque.svg";
import { MdOutlineVideoCameraFront } from "react-icons/md";
import { BsChatLeftText } from "react-icons/bs";
import video from "../../../Assets/Images/video.svg";
import AppointmentService from "../../../Services/AppointmentService";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import LiveChat from "../../Pages/LiveChat";

dayjs.extend(utc);
dayjs.extend(relativeTime);

function PatientQueue({ onClose }) {
  const [queueData, setQueueData] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(null);
  const location = useLocation();
  const history = useHistory();
  const [chatOpen, setChatOpen] = useState(false);
  const [chatData, setChatData] = useState();

  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    getQeueCount();
    fetchAllAppts();
  }, []);

  // const handleClick = (record) => {
  //   const currentPath = location.pathname;

  //   if (currentPath === "/videocall") {
  //     message.error("You cannot change the patient while in a video call.");
  //   } else {
  //     let payload = {
  //       appointmentId: record.appointmentId,
  //       modifiedBy: record.userId,
  //       modifiedDate: CommonFunctions.convertUTCDate(
  //         new Date(),
  //         "YYYY-MM-DD HH:mm:ss"
  //       ),
  //       patientId: record.patientId,
  //       startDateTime: CommonFunctions.convertUTCDate(
  //         new Date(),
  //         "YYYY-MM-DD HH:mm:ss"
  //       ),
  //       userId: record.userId,
  //     };

  //     ConsultationService.updateStartTime(payload).then((res) => {
  //     });

  //     let patientPayload = {
  //       patientId: record.patientId,
  //     };

  //     setLoading(true);

  //     PatientService.PatientListFilter(patientPayload)
  //       .then((res) => {
  //         if (res?.data?.length > 0) {
  //           sessionStorage.setItem("patient", JSON.stringify(res.data[0]));
  //         } else {
  //           console.warn("No patient data found.");
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching patient data:", error);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });

  //     setLoading(true);

  //     AppointmentService.AppointmentFilter(payload)
  //       .then((res) => {
  //         if (res?.data?.length > 0) {
  //           history.push(APP_ROUTES.VIDEOCALL, {
  //             selectedPatient: res.data[0],
  //           });
  //         }
  //         //  else {
  //         //   console.warn("No appointment data found.");
  //         // }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching appointment data:", error);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });

  //     return;
  //     history.push(APP_ROUTES.VIDEOCALL, { selectedPatient: record });
  //   }
  // };

  const handleClick = async (record, tab) => {
    const currentPath = location.pathname;

    if (currentPath === "/videocall") {
      message.error("You cannot change the patient while in a video call.");
      return;
    }
    setLoading(true);
    if (tab === "1") {
      let payload = {
        appointmentId: record.appointmentId,
        modifiedBy: record.userId,
        modifiedDate: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        patientId: record.patientId,
        startDateTime: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        userId: record.userId,
        userName: record?.userName,
        personType: "Doctor",
      };

      ConsultationService.updateStartTime(payload).then((res) => { });
    }
    try {
      let payload = {
        patientId: record.patientId,
      };

      PatientService.PatientListFilter(payload).then((res) => {
        sessionStorage.setItem("patient", JSON.stringify(res.data[0]));
      });

      let apptPayload = {
        appointmentId: record.appointmentId,
      };

      let result = await AppointmentService.AppointmentFilter(apptPayload);
      history.push(APP_ROUTES.VIDEOCALL, { selectedPatient: result?.data[0] });
      window.scrollTo(0, 0);
    } catch (error) {
      message.error("An error occured try again");
    } finally {
      setLoading(false);
    }
  };

  function getConnectionTimeText(utcDateTime) {
    if (!utcDateTime) return "";
    const localTime = dayjs.utc(utcDateTime).local();
    return `Connected ${localTime.fromNow()}`;
  }

  const getQeueCount = async () => {
    let payload = {
      fromDate: dayjs(new Date()).format("MM/DD/YYYY"),
      toDate: dayjs(new Date()).format("MM/DD/YYYY"),
      userId: loginResultObject?.user.userId,
      account_Id: loginResultObject.user.account_Id,
      clinic_Id: loginResultObject.user.clinic_Id,
      completedStatus: 2,
      pendingStatus: 1,
      totalAppointmentStatus: 3,
    };

    try {
      let countResult = await AppointmentService.GetQeueCount(payload);
      setCount(countResult.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAllAppts = () => {
    const userObj = sessionStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;
    const currSelClinicId = sessionStorage.getItem("defaultClinic");

    let payload = {
      // account_Id: userData.user.account_Id,
      clinic_Id: currSelClinicId,
      appointmentQueueDate: dayjs().format("MM/DD/YYYY"),
      userId: userData.user.userId,
      status: 1,
    };
    PatientService.patientQueueList(payload).then((res) => {
      if (res.data) {
        //   let validate = res?.data?.filter(
        //     (x) => x.appointmentId != userData?.user?.appointmentId
        //   );
        //   if (validate && validate.length) {
        setQueueData(res.data);

        // } else {
        //   message.warning("No patient available in queue");
        // }
      } else {
        setQueueData([]);
        message.warning("No patient available in queue");
      }
    });
  };

  const handleReload = () => {
    fetchAllAppts();
    getQeueCount();
  };

  const getInitials = (name) => {
    if (!name) return "";
    name = name.replace(/^Mr\.?\s*/, "").trim();
    const initials = name.slice(0, 1).toUpperCase();
    return initials;
  };
  const handleChatOpen = async (qData) => {
    let payload = { patientId: qData.patientId };
    const response = await PatientService.PatientListFilter(payload);
    sessionStorage.setItem("qChat", JSON.stringify(response.data[0]));
    setChatData(qData);
    setChatOpen(true);
  };

  const handleChatClose = () => {
    setChatOpen(false);
  };

  return (
    <div
      className={`fixed inset-0 z-50 bg-black/40 opacity-10 flex justify-end ${isVisible ? "opacity-100" : "opacity-0"
        } transition-opacity duration-700 overflow-hidden`}
    >
      {loading && (
        <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="spinner"></div>
        </div>
      )}
      <section className="flex flex-col bg-white rounded-md mt-14 mb-10 shadow-2xl w-[330px]">
        <header className="flex gap-5 justify-between self-center w-full max-w-[309px] mt-3">
          <h2 className="text-sm font-semibold font-sans text-zinc-800">
            Patient Queue
          </h2>
          <div className="flex gap-3">
            <div className=" cursor-pointer" onClick={() => handleReload()}>
              {/* <IoReloadCircle size={27} /> */}
              <GrRefresh className="w-4 h-4 mt-[2px]" />
            </div>
            <div className="cursor-pointer" onClick={onClose}>
              {/* <IoIosCloseCircle size={27} /> */}
              <IoCloseSharp className="w-5 h-5" />
            </div>
          </div>
        </header>
        <div className="w-full border border-gray-200 border-solid bg-[#F6FEFF]">
          <div className="w-full mx-3 flex items-center gap-12">
            <div>
              <div className="flex gap-2 w-full mt-1">
                <div className="flex gap-1.5 items-start self-start text-xs leading-4 text-zinc-800 w-full">
                  <div
                    className="flex shrink-0 h-4 bg-brand-primaryColor rounded-md w-[3px] mt-1"
                    aria-hidden="true"
                  />
                  <div className="flex gap-2 items-center">
                    <h3 className="w-32 font-sans font-normal ">
                      Today Appointments:
                    </h3>

                    <h3 className="text-sm font-semibold text-zinc-800">
                      {count?.TOTAL_APPOINTMENT_COUNT
                        ? count?.TOTAL_APPOINTMENT_COUNT
                        : "-"}
                    </h3>
                  </div>
                </div>
              </div>

              {/* Completed Appointments */}
              <div className="flex gap-5 justify-between mt-0.5 w-full max-w-[157px]">
                <div className="flex gap-1 items-center self-start text-xs leading-4 text-zinc-800">
                  <div
                    className="flex shrink-0 self-stretch my-auto h-4 bg-emerald-400 rounded-md w-[3px]"
                    aria-hidden="true"
                  />
                  <div className="flex gap-2 items-center mt-1">
                    <h3 className="w-32 font-sans font-normal">Completed:</h3>

                    <h3 className="text-sm font-semibold text-zinc-800">
                      {count?.COMPLETED_APPOINTMENT_COUNT
                        ? count?.COMPLETED_APPOINTMENT_COUNT
                        : "-"}
                    </h3>
                  </div>
                </div>
              </div>

              {/* Pending Appointments */}
              <div className="flex gap-5 justify-between mt-0.5 w-full max-w-[157px]">
                <div className="flex gap-1 items-center self-start text-xs leading-4 text-zinc-800">
                  <div
                    className="flex shrink-0 self-stretch my-auto h-4 bg-yellow-500 rounded-md w-[3px]"
                    aria-hidden="true"
                  />
                  <div className="flex gap-2 items-center mt-1">
                    <h3 className="w-32 font-sans font-normal">Pending:</h3>

                    <h3 className="text-sm font-semibold text-zinc-800">
                      {count?.PENDING_APPOINTMENT_COUNT
                        ? count?.PENDING_APPOINTMENT_COUNT
                        : "-"}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img src={Quie} alt="" className="h-16" />
            </div>
          </div>
          <div className="mt-3 w-full border border-gray-200 border-solid min-h-px" />
        </div>
        <div
          className="flex flex-col gap-1.5 self-start mt-4 h-[500px] mb-5 w-full px-3 overflow-y-scroll"
        // id="unquie-scroll"
        >
          <div className="flex flex-col gap-3 w-full bg-white ">
            {queueData ? (
              queueData.map((option, index) => (
                <React.Fragment key={index}>
                  <div className="rounded border border-solid border-neutral-200 p-1">
                    <div className="flex gap-5 justify-between w-full">
                      <div className="flex gap-1 items-center text-xs leading-4 text-zinc-800">
                        {/* <img
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/d3cc355c861a79577bb1fd9a78696f949ee894c4?placeholderIfAbsent=true&apiKey=65fc54ab571d4077a028b2b6fa8483e5"
                          className="object-contain shrink-0 self-stretch my-auto w-8 rounded-3xl aspect-square shadow-[0px_2px_2px_rgba(0,0,0,0.1)]"
                          alt={`${option.patientName}'s profile`}
                        /> */}
                        {option.patientPhotoName ? (
                          <img
                            src={
                              process.env.REACT_APP_IMAGE_URL +
                              option?.patientPhotoName
                            }
                            alt={option.name}
                            className="object-contain shrink-0 self-stretch my-auto w-8 rounded-3xl aspect-square shadow-[0px_2px_2px_rgba(0,0,0,0.1)]"
                          />
                        ) : (
                          <div className="h-8 w-8 rounded-full flex items-center justify-center text-white bg-brand-primaryColor">
                            <span>{getInitials(option.patientName)}</span>
                          </div>
                        )}
                        <span className="self-stretch my-auto">
                          <h4 className="font-sans text-black text-sm">
                            {option.patientName}
                          </h4>
                        </span>
                      </div>

                      <div className="flex gap-3 items-center my-auto">
                        <button
                          disabled={option.queueStatus === "Y"}
                          className={`w-8 h-8 rounded-full flex items-center justify-center cursor-pointer disabled:cursor-not-allowed ${option.queueStatus === "Y"
                              ? "bg-[#2ff66b]"
                              : "bg-[#DEF3F2]"
                            }`}
                        >
                          {loading ? (
                            <img
                              src={video}
                              alt="img"
                            // onClick={() => handleClick(option, "1")}
                            />
                          ) : (
                            <img
                              src={video}
                              alt="img"
                              onClick={() => handleClick(option, "1")}
                            />
                          )}
                        </button>
                        <div className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer">
                          <BsChatLeftText
                            onClick={() => handleChatOpen(option)}
                            className="text-cyan-700"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex gap-3 items-center self-start mt-2 text-[10px]">
                      <div className="flex  gap-1 justify-center items-center">
                        <div className="gap-px self-stretch px-1 py-1 my-auto bg-rose-200 rounded text-zinc-800">
                          <label>
                            {option.startTime}- {option.endTime}
                          </label>
                        </div>
                        <div className="text-center mt-2">
                          <p>
                            {option.queueStatus === "Y" ? (
                              <span className="text-[#189FAA]">Ongoing</span>
                            ) : (
                              <span className="text-yellow-500">Pending</span>
                            )}
                          </p>
                        </div>
                      </div>

                      <div className="shrink-0 self-stretch my-auto w-0 border border-gray-200 border-solid h-[22px]" />
                      {option?.startDateTime && (
                        <div className="self-stretch my-auto text-red-600">
                          {getConnectionTimeText(option?.startDateTime)}
                        </div>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ))
            ) : (
              <div className="flex items-center justify-center">
                <p>No patient available in queue</p>
              </div>
            )}
          </div>
        </div>
      </section>
      <Drawer
        closeIcon={false}
        open={chatOpen}
        destroyOnClose
        onClose={handleChatClose}
      >
        <LiveChat />
      </Drawer>
    </div>
  );
}

export default PatientQueue;
